import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-brand-ink text-brand-bone/90 mt-0"
    >
      <div className="container-x py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
            <div
              aria-label="Goyam Ingredients"
              className="h-20 w-64 bg-center bg-no-repeat"
              style={{
                backgroundImage: `url(${COMPANY.logoUrl})`,
                backgroundSize: "170% auto",
              }}
            />
          </Link>
          <p className="text-sm text-brand-bone/70 leading-relaxed max-w-md">
            A trusted sourcing and importing partner for cosmetic and BPC raw
            materials. Connecting global manufacturers with Indian formulators
            through quality, consistency and care.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow !text-brand-gold mb-5">Explore</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-brand-bone/75 hover:text-brand-terracotta transition"
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="eyebrow !text-brand-gold mb-5">Get in touch</p>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 mt-1 text-brand-terracotta shrink-0" />
              <span className="text-brand-bone/75">{COMPANY.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone className="w-4 h-4 mt-1 text-brand-terracotta shrink-0" />
              <a href={COMPANY.phoneHref} className="text-brand-bone/75 hover:text-brand-terracotta">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex gap-3">
              <Mail className="w-4 h-4 mt-1 text-brand-terracotta shrink-0" />
              <a href={COMPANY.emailHref} className="text-brand-bone/75 hover:text-brand-terracotta break-all">
                {COMPANY.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-brand-bone/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-brand-bone/50">
          <span>© {new Date().getFullYear()} Goyam Ingredients. All rights reserved.</span>
          <span className="tracking-[0.2em] uppercase">Sourcing · Importing · Technical Support</span>
        </div>
      </div>
    </footer>
  );
}
